import defaultReducer from "./defaultReducer";

export const mainMenuState = {
  section: null,
  collapsed: true,
  activeIndex: 0,
  panes: [],
  orgDirectoryWidth: 230,
};

export default defaultReducer("MAIN_MENU", mainMenuState);
